export const sanitizeText = (value) => {
  if (typeof value !== 'string') return value;
  return value
    .replace(/[<>]/g, '')
    .replace(/[\u0000-\u001f\u007f-\u009f]/g, '');
};

export const sanitizeEmail = (value) => {
  if (typeof value !== 'string') return value;
  return sanitizeText(value).replace(/\s+/g, '');
};

export const sanitizePhone = (value) => {
  if (typeof value !== 'string') return value;
  return sanitizeText(value).replace(/[^0-9+\-\s()]/g, '').trim();
};

export const countWords = (value) => {
  if (typeof value !== 'string') return 0;
  return value.trim().split(/\s+/).filter(Boolean).length;
};

export const sanitizeFormObject = (formObject) => {
  if (typeof formObject !== 'object' || formObject === null) return formObject;
  return Object.entries(formObject).reduce((acc, [key, value]) => {
    if (typeof value === 'string') {
      const raw = key === 'phone' ? sanitizePhone(value) : sanitizeText(value);
      acc[key] = typeof raw === 'string' ? raw.trim() : raw;
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
};
